import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=7f78b3f9&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=7f78b3f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f78b3f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f78b3f9')) {
      api.createRecord('7f78b3f9', component.options)
    } else {
      api.reload('7f78b3f9', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=7f78b3f9&scoped=true&", function () {
      api.rerender('7f78b3f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/settings/Notification.vue"
export default component.exports